import { render, staticRenderFns } from "./NoticiaView.vue?vue&type=template&id=6273d207&scoped=true"
import script from "./NoticiaView.vue?vue&type=script&lang=js"
export * from "./NoticiaView.vue?vue&type=script&lang=js"
import style0 from "./NoticiaView.vue?vue&type=style&index=0&id=6273d207&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6273d207",
  null
  
)

export default component.exports